import browse from './browse.vue';
import form from './form.vue';
import media from './media';
import read from './read.vue';
import securables from './securables';

export default {
  browse,
  create: form,
  read,
  edit: form,
  media,
  securables,
};
